import { LuSearch, LuChevronDown,BsThreeDots } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",

      rows: {
        row1: [
          {
            name: "customerBranchName",
            label: "Branch Name",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "customerAddressIsSetAsDefault",
            checkboxLabel: "Set as default",
            component: "checkboxbox",
          },
            {
              name: "customerAddressIsDeactivate",
              checkboxLabel: "Deactivate",
              component: "checkboxbox",
            },
        ],
        row3:[
          {
            name: "customerAddressLine",
            actionText:"Address",
            component: "textarea",
            width: "100%",
            height: 100,
        },
        ],
        row4: [
          {
            name: "countryId",
            label: "Country",
            component: "text-field",
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
            icon: LuSearch,
            linkedValue: "countryId",
            required:true

              },
          {
            name: "customerAddressTelephone",
            label: "Telephone",
            component: "text-field",
          },
        ],
        row5: [
          {
            name: "cityId",
            label: "City",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCity",
            dependsOn: "stateId",
            useLinkedValue : "stateId",
            required:true

          },
          {
            name: "customerAddressPostalCode",
            label: "Postal Code",
            component: "text-field",
          },
        ],
        row6: [

          {
            name: "stateId",
            label: "State/Province",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getState",
            useLinkedValue: "countryId",
            linkedValue : "stateId",
            required:true

          },
          {
            name: "customerAddressFax",
            label: "Fax",
            component: "text-field",
          },
        ],
        row7: [
          {
            name: "customerAddressWebsite",
            label: "Website",
            component: "text-field",
          },
          {
            name: "customerAddressEmailAddress",
            label: "Email",
            component: "text-field",
          },
        ],
        row8: [
          {
            name: "customerAddressSalesPerson",
            label: "Sales Person",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            disabled:true
          },
          {
            name: "customerAddressTaxableType",
            label: "Taxable Type",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options:[
              {label:"Standard",name:"standard"},
              {label:"SEZ",name:"SEZ"},
              {label:"Exempt",name:"Exempt"},
              {label:"Composite Supplier",name:"Composite"},
            ]
          },
        ],

      },
    },
  ],
};
